import { createAsyncThunk, createSlice, createAction } from "@reduxjs/toolkit"
import { clientGraphQLAuthMutation } from '../../../../core/data/GraphQLApi';
import { ExceptionManager } from '../../../../core/logManager';

import { resetALL } from '../../../../.globals/redux/actions';

//STATE INITIAL
const INIT_STATE = {
    loading: false,
    showConfirm: false,
    error: null,
    result: false,
};

const route = 'core/views/forgotPassword/redux/slice'

export const forgotPasswordRequest = createAsyncThunk('forgotPassword/request',
    async ({ username }, { rejectWithValue }) => {
        try {

            const data = await clientGraphQLAuthMutation(`
             	mutation ($username: String!) {
					result: forgotPassword(username: $username) { username }
				}
            `,
                {
                    username
                }
            )

            return data.result
        } catch (exc) {
            ExceptionManager(exc, route, "forgotPasswordRequest");
            return rejectWithValue(exc);
        }
    });

//Slice
const forgotPasswordRedux = createSlice({
    name: 'forgotPassword',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        },
        showConfirm(state, action) {
            state.showConfirm = true
        },
        showConfirmClose(state, action) {
            state.showConfirm = false
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        builder.addCase(forgotPasswordRequest.pending, (state) => {
            state.loading = true
            state.error = null
        });
        builder.addCase(forgotPasswordRequest.fulfilled, (state, action) => {
            return { ...state, loading: false, result: action.payload }
        });
        builder.addCase(forgotPasswordRequest.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
})

export const { actions, reducer } = forgotPasswordRedux;

// Extract and export each action creator by name
export const { reset } = actions;
export default reducer;